import React, { Component } from "react";
import RewardssettingsInside from "RewardssettingsRewardssettings";

export default class Gamification extends Component {
    render() {
        return (
            <RewardssettingsInside history={this.props.history} />
        );
    }
}